import { render, staticRenderFns } from "./MailtoLink.vue?vue&type=template&id=208e93be"
import script from "./MailtoLink.vue?vue&type=script&lang=js"
export * from "./MailtoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports